var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwardMiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41820_9082)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41820_9082",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41820_9082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 4.25C13.6875 3.25 12.25 2.625 10.625 2.5V1.25C12.5625 1.375 14.3125 2.1875 15.75 3.375L14.875 4.25ZM1.4375 5.75H3.375L4.5 7.375C4.5625 7.5 4.75 7.4375 4.8125 7.3125L5.375 5.4375L7.25 4.875C7.375 4.8125 7.4375 4.625 7.3125 4.5625L5.75 3.375L5.8125 1.4375C5.8125 1.3125 5.625 1.1875 5.5625 1.3125L3.9375 2.4375L2.0625 1.8125C1.9375 1.8125 1.8125 1.9375 1.8125 2.0625L2.4375 3.9375L1.3125 5.5C1.1875 5.625 1.3125 5.75 1.4375 5.75ZM17.5 9.375H18.75C18.625 7.4375 17.8125 5.6875 16.625 4.25L15.75 5.125C16.75 6.3125 17.375 7.75 17.5 9.375ZM1.25 9.375H2.5C2.5625 8.6875 2.75 8 2.9375 7.3125L2.6875 7H1.6875C1.5 7.75 1.3125 8.5625 1.25 9.375ZM4.25 16.625C5.625 17.8125 7.4375 18.625 9.375 18.75V17.5C7.75 17.375 6.3125 16.75 5.125 15.75L4.25 16.625ZM15.75 14.875L16.625 15.75C17.8125 14.375 18.625 12.5625 18.75 10.625H17.5C17.375 12.25 16.75 13.6875 15.75 14.875ZM1.25 10.625C1.375 12.5625 2.1875 14.375 3.375 15.75L4.25 14.875C3.25 13.6875 2.625 12.25 2.5 10.625H1.25ZM10.625 17.5V18.75C12.5625 18.625 14.3125 17.8125 15.75 16.625L14.875 15.75C13.6875 16.6875 12.25 17.375 10.625 17.5ZM10 14.375C7.5625 14.375 5.625 12.4375 5.625 10C5.625 7.5625 7.5625 5.625 10 5.625C12.4375 5.625 14.375 7.5625 14.375 10C14.375 12.4375 12.4375 14.375 10 14.375ZM8.9375 12.9375C8.625 12.375 8.375 11.5 8.3125 10.5H6.9375C7.125 11.625 7.875 12.5 8.9375 12.9375ZM8.9375 7.0625C7.875 7.4375 7.125 8.375 6.9375 9.5H8.3125C8.375 8.5 8.625 7.6875 8.9375 7.0625ZM10.75 10.4375H9.25C9.3125 11.625 9.75 12.5 10 12.9375C10.3125 12.5 10.6875 11.6875 10.75 10.4375ZM10.75 9.5C10.6875 8.3125 10.25 7.4375 10 7C9.6875 7.4375 9.3125 8.3125 9.25 9.5H10.75ZM13.0625 10.4375H11.6875C11.625 11.5 11.375 12.3125 11.0625 12.875C12.125 12.5 12.875 11.625 13.0625 10.4375ZM13.0625 9.5C12.875 8.375 12.125 7.4375 11.0625 7.0625C11.375 7.625 11.625 8.5 11.6875 9.5H13.0625Z",
    fill: "#BFA247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41820_9082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwardMiles);
export default __webpack_public_path__ + "static/media/icon-award-miles.e6e5d811e22af4bf4126e593daa96268.svg";
export { ForwardRef as ReactComponent };